const rows = [
  { label: 'Zielgruppe', geistige: 'Werkstätten / Förderschulen', psychische: 'Werkstätten / Förderschulen', ready: 'Schulen / Bildungsträger' },
  { label: 'Module', geistige: '9', psychische: '9', ready: '10' },
  { label: 'Dauer pro Modul', geistige: '120 Min.', psychische: '120 Min.', ready: '90 Min.' },
  { label: 'Materialien', geistige: '✓', psychische: '✓', ready: '✓' },
  { label: 'Videokurs', geistige: '✓', psychische: '✓', ready: '✓' },
  { label: 'Einmaliger Erwerb', geistige: '✓', psychische: '✓', ready: '✓' },
];

const benefits = [
  {
    icon: 'ri-checkbox-circle-line',
    title: 'Fertig entwickelt',
    text: 'Kein eigenes Konzept von Grund auf erstellen – alles ist bereits ausgearbeitet.',
  },
  {
    icon: 'ri-play-circle-line',
    title: 'Direkt einsetzbar',
    text: 'Strukturierte Module, Materialien und Zeitabläufe sind bereits vorhanden.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Zielgruppengerecht',
    text: 'Inhalte und Materialien sind auf die jeweilige Zielgruppe abgestimmt.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Praxisorientiert',
    text: 'Methoden, Übungen und Tools können unmittelbar eingesetzt werden.',
  },
  {
    icon: 'ri-time-line',
    title: 'Dauerhaft nutzbar',
    text: 'Einmal erwerben – dauerhaft in der Einrichtung einsetzen, ohne Lizenzgebühren.',
  },
];

export default function Comparison() {
  return (
    <section id="vergleich" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              Was bekomme ich konkret?
            </h2>
          </div>
        </div>

        <div className="mt-10 overflow-x-auto rounded-lg border border-background-200 bg-background-50">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-4 font-semibold text-foreground-500">
                  Merkmal
                </th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-950">
                  Geistige Beeinträchtigung
                </th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-950">
                  Psychische Beeinträchtigung
                </th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-950">
                  Ready for Work
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.label} className={i % 2 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-5 py-3.5 text-foreground-700 font-medium whitespace-nowrap">
                    {row.label}
                  </td>
                  <td className="px-5 py-3.5 text-foreground-800">{row.geistige}</td>
                  <td className="px-5 py-3.5 text-foreground-800">{row.psychische}</td>
                  <td className="px-5 py-3.5 text-foreground-800">{row.ready}</td>
                </tr>
              ))}
              <tr className="bg-primary-50">
                <td className="px-5 py-4 font-semibold text-foreground-950 whitespace-nowrap">
                  Preis
                </td>
                <td className="px-5 py-4 font-heading text-lg font-semibold text-primary-700">
                  899 €
                </td>
                <td className="px-5 py-4 font-heading text-lg font-semibold text-primary-700">
                  899 €
                </td>
                <td className="px-5 py-4 font-heading text-lg font-semibold text-primary-700">
                  1.199 €
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-16">
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">
            Warum meine Kurskonzepte?
          </h3>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {benefits.map((b) => (
              <div
                key={b.title}
                className="rounded-lg bg-background-50 border border-background-200 p-5"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                  <i className={`${b.icon} text-xl`}></i>
                </span>
                <h4 className="mt-4 text-sm font-semibold text-foreground-950">{b.title}</h4>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}